
// AuthProvider.jsx
import { createContext, useContext, useEffect, useState } from "react";
import { fetchMe, logout as apiLogout } from "./auth";
import { API_BASE, setCsrfToken } from "./server";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    (async () => {
      try {
        // Fetch CSRF token on app load (from response body, not cookie)
        const csrfRes = await fetch(`${API_BASE}/users/auth/csrf/`, {
          credentials: "include",
        });
        const csrfData = await csrfRes.json().catch(() => ({}));
        if (csrfData.csrftoken) setCsrfToken(csrfData.csrftoken);

        const data = await fetchMe(); // returns null if not logged in
        if (mounted) setUser(data);
      } catch (e) {
        // treat as logged out on any error
        if (mounted) setUser(null);
      } finally {
        if (mounted) setLoading(false);
      }
    })();

    return () => {
      mounted = false;
    };
  }, []);

  const logout = async () => {
    await apiLogout();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
